/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelTabs64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelTabs64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M52 49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15C12 13.3431 13.3431 12 15 12H48.5C50.433 12 52 13.567 52 15.5V49ZM51 49C51 50.1046 50.1046 51 49 51H15C13.8954 51 13 50.1046 13 49V15C13 13.8954 13.8954 13 15 13H25.5V19C25.5 20.1046 26.3954 21 27.5 21H49C50.1046 21 51 21.8954 51 23V49ZM51 20.7639V15.5C51 14.1193 49.8807 13 48.5 13H40V20H49C49.7684 20 50.4692 20.2889 51 20.7639ZM39 20V13H26.5V19C26.5 19.5523 26.9477 20 27.5 20H39Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelTabs64Icon.tags = ['tabs', 'window', 'add', 'interface', 'new'];

AddPanelTabs64Icon.category = '64x64 (Add panel)';

AddPanelTabs64Icon.iconSize = 64;
